'use strict';

var _ = require('lodash');
var marketScreenProfileTooltip = _.template(require('../templates/profile-chart-tooltip-market-screen.html'));
var flightScreenProfileTooltip = _.template(require('../templates/profile-chart-tooltip-flight-screen.html'));
var ProfileChartController = function ProfileChartController($q, $scope, $timeout, $rootScope, dataProviderService, chartFormatter, featureToggleService, BrushSelectionFilter, ProfileChartConstants, profileChartUrdSettingProviderService, constants) {
  $scope.legendItems = [];
  $scope.label = $scope.metrics.selectedMetric.label + ' Profile';
  $scope.isLegendCollapsible = false;
  $scope.legendFilter = [];
  var MAX_LEGEND_ITEMS_PER_LINE = 8;
  var filterType = 'profileChart';
  $scope.initChart = function () {
    $scope.tooltipTemplateFn = _.isEqual($scope.screen, constants.MARKET_SCREEN) ? marketScreenProfileTooltip : flightScreenProfileTooltip;
    $scope.changeMetricHandler();
  };
  $scope.reloadChart = function (ignoreLegend) {
    $scope.ignoreLegend = ignoreLegend;
    $scope.updateProfileChart();
  };
  $scope.$on('chart-legend:legend-item-toggle', function (event, data) {
    if (data.selected) {
      _.pull($scope.legendFilter, data.id);
    } else {
      $scope.legendFilter.push(data.id);
    }

    // added to allow Sly to set the component as active
    $timeout(function () {
      $scope.reloadChart(true);
    }, 0);
  });
  $scope.dimension = featureToggleService.isEnabled('MAPPED_MODE') ? 'regular' : 'mapped';
  $scope.updateProfileChart = function () {
    $scope.setLoadingMessage();
    var params = _.pick($scope, ['target', 'screen', 'mode', 'subMode', 'dimension', 'showCapacity', 'legendFilter', 'selectedService']);
    params.selectedMetric = $scope.metrics.selectedMetric.id;
    params.selectedReference = _.get($scope, ['screenState', 'selectedReference']);
    dataProviderService.getCurveData(params).then(function (chartData) {
      $scope.chartData = chartData;
      $scope.renderChart(chartData.data);
      $scope.legendItems = chartData.legend;
      if (!$scope.ignoreLegend) {
        $scope.isLegendCollapsible = $scope.legendItems.length > MAX_LEGEND_ITEMS_PER_LINE;
      }
    });
  };

  //dimension change handler
  $scope.$on($scope.screen + '-' + $scope.mode + ':dimensionChanged', function (event, dimension) {
    $scope.dimension = dimension;
    $scope.updateProfileChart();
  });
  $scope.changeMetricHandler = function () {
    if ($scope.metrics.selectedMetric.chartType === 'profile-chart') {
      $scope.label = $scope.metrics.selectedMetric.label + ' Profile';
      if ($scope.screen === constants.FLIGHT_SCREEN) {
        $scope.$emit('brush-filter:filterApplied', new BrushSelectionFilter(filterType, []));
      }
      $scope.setSelectedDtd(null);
      $scope.resetFilters();
      $scope.updateProfileChart();
    }
  };
  $scope.chartFormatters = {
    xAxisTickFormatter: chartFormatter.humanReadable,
    yAxisTickFormatter: chartFormatter.humanReadable,
    tooltipFormatter: function tooltipFormatter(curves) {
      var content = dataProviderService.buildTooltip(curves, $scope.metrics.selectedMetric.label);
      return $scope.tooltipTemplateFn(content);
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'profile-chart-tooltip';
  $scope.handlePinDown = _.debounce(function (dtd) {
    if (_.isUndefined(dtd)) {
      // emit brush-filter:filterApplied with empty array to hide class mix graph
      $scope.$emit('brush-filter:filterApplied', new BrushSelectionFilter(filterType, []));
    } else {
      if ($scope.metrics.selectedMetric.id === 'loadFactor') {
        return;
      }
      var filterParameters = {
        metric: $scope.metrics.selectedMetric.label.toLowerCase(),
        daysToDeparture: dtd
      };
      var brushFilter = new BrushSelectionFilter(filterType, [filterParameters]);
      $scope.$emit('brush-filter:filterApplied', brushFilter);
    }
  }, 10);
  $scope.expandChart = function () {
    $rootScope.$broadcast('profile-chart-panel:swap', true, {
      selectedService: $scope.chartData.entity,
      primaryEntity: $scope.chartData.entity,
      screenMode: constants.FLIGHT_ANALYSIS_MODE,
      selectedMetric: $scope.metrics.selectedMetric,
      target: $scope.target,
      screen: $scope.screen,
      mode: $scope.mode,
      subMode: $scope.subMode,
      legendFilter: $scope.legendFilter,
      showCapacity: $scope.showCapacity
    });
  };
  $scope.resetFilters = function () {
    $scope.ignoreLegend = false;
    $scope.legendFilter = profileChartUrdSettingProviderService.getUrdFilter($scope.screen, $scope.mode);
  };
};
ProfileChartController.$inject = ['$q', '$scope', '$timeout', '$rootScope', 'ProfileChartDataProviderService', 'FormatterService', 'FeatureToggleService', 'BrushSelectionFilterFactory', 'ProfileChartConstants', 'ProfileChartUrdSettingProviderService', 'DataRetrieverConstantsService'];
module.exports = ProfileChartController;